<template>
 <div>
    <el-dialog  title="用户列表" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"
      @close="closeDialog" :visible.sync="userMark" width="800px" center>
      <span>
        <el-table :data="YHlist"  bordersize="mini"  style="width: 100%" height="400"  center border>
          <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column prop="userName"  width="200"  label="用户姓名"></el-table-column>
          <el-table-column prop="userAccount"  min-width="200" label="登录名"></el-table-column>
          <el-table-column prop="orgName"  width="200"  label="组织机构"></el-table-column>
      </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userMark = false" size="mini"  type="primary">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { findUserByRoleId } from '@/api/newCrm'
export default {
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      userMark: false,
      YHlist: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.rowData.id) {
      findUserByRoleId({ roleId: this.rowData.id }).then(res => {
        this.YHlist = res
        this.userMark = true
      })
    }
  },
  methods: {
    closeDialog () {
      this.$emit('destroy')
    }

  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
/deep/.yewuBtn{
  background-color: #fff;
  padding: 7px 30px;
  color: #0c46a2;
}
/deep/.el-tag{
  margin-right:20px;
}
</style>
